import { StoreState } from '@/redux/types';
import { selectBasketItems } from './selectBasketItems';

export const getBasketItemsByProductId = (state: StoreState, productId?: string) =>
  productId ? selectBasketItems(state).filter((item) => item.productId === productId) : [];
